import * as TypesPayment from '../types/types_payment';
import Vue from 'vue';

export default {
    state: {
        goods: {},
        miniAmount: 0, // 小程序订单金额
        packageMoneyInfo: {}
    },
    mutations: {
        [TypesPayment.PAYMENT_SET_GOODS](state, payload) {
            state.goods = payload || {};
        },
        // 存入小程序订单金额
        [TypesPayment.SMALLROUTINE_AMOUNT_GET](state, params) {
            state.miniAmount = params.amount;
        },
        // 课时包支付
        [TypesPayment.PAYMENT_PACKAGE_GOOD](state, params) {
            state.packageMoneyInfo = params;
        }
    },
    actions: {
        // 获取获取商品列表(学费和豆豆)
        [TypesPayment.PAYMENT_GET_GOODS](ctx) {
            return Vue.http.get('/v1/payments/goods-list')
                .then(resp => {
                    return Vue.checkResp(resp, {});
                }).then(data => {
                    ctx.commit(TypesPayment.PAYMENT_SET_GOODS, data);
                    return data;
                }).catch(err => {
                    ctx.commit(TypesPayment.PAYMENT_SET_GOODS, null);
                    throw err;
                });
        },
        // 发起支付
        [TypesPayment.PAYMENT_READY_INfO](ctx, { goodsType, goodsNo, copies, payThrough, deviceType }) {
            return Vue.http.post('/v1/payments', { goodsType, goodsNo, copies, payThrough, deviceType })
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    return data;
                }).catch(err => {
                    throw err;
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_payment.js